import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { TableRowActionsModel } from '../../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../../shared/interfaces/actions';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzFormModule } from 'ng-zorro-antd/form';
import { FormsModule } from '@angular/forms';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { LookupService } from '../../../../services/lookup.service';
import {
  DialogConfig,
  DialogService,
} from '../../../../shared/services/dialog.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { ErrorAlertService } from '../../../../shared/services/error-alert.service';
import { ListService } from '../../../../shared/services/list.service';
import { CommonModule } from '@angular/common';
import { LookupValueItem } from '../../../../interfaces/lookup.interface';
import { TimesheetStaffErrorcodeComponent } from "../timesheet-staff-errorcode/timesheet-staff-errorcode.component";
import { STATIC_DATA } from '../../../../shared/constants/static-data.constants';
import { SectionsService } from '../../../../services/sections.service';
import { AuthorizationDetailsComponent } from "../../authorizations/authorization-details/authorization-details.component";
import { TimesheetStaffDeniedReasonsComponent } from "../timesheet-staff-deniedreasons/timesheet-staff-deniedreasons.component";
import { TimesheetStaffAuthDataComponent } from "../timesheet-staff-authdata/timesheet-staff-authdata.component";
import { ButtonComponent } from "../../../../shared/components/button/button.component";
import { TimesheetNewEntriesComponent } from '../timesheets-add-entries/timesheets-add-entries.component';
import { UserService } from '../../../../services/user.service';
import CommonUtil from '../../../../shared/authorization/common.util';
import { DateTimeFormatterService } from '../../../../shared/utils/date-time-formatter.service';

@Component({
  selector: 'ppl-timesheet-detail-view',
  standalone: true,
  imports: [
    CommonModule,
    ListTableComponent,
    NzSelectModule,
    NzFormModule,
    FormsModule,
    NzDividerModule,
    TimesheetNewEntriesComponent,
    TimesheetStaffErrorcodeComponent,
    AuthorizationDetailsComponent,
    TimesheetStaffDeniedReasonsComponent,
    TimesheetStaffAuthDataComponent,
    ButtonComponent
  ],
  templateUrl: './timesheet-detail-view.component.html',
  styleUrl: './timesheet-detail-view.component.css',
})
export class TimesheetDetailViewComponent implements OnInit {
  @Input() lineItem?: any;
  @Input() isProviderView?: boolean = false;
  @Input() rowData?: any;
  @ViewChild('pendedDialog') pendedDialog!: TemplateRef<any>;
  @ViewChild('deniedDialog') deniedDialog!: TemplateRef<any>;
  @ViewChild('authDataDialog') authDataDialog!: TemplateRef<any>;
  private dialogSvc = inject(DialogService);
  @ViewChild('authDialog') authDialog!: TemplateRef<any>;
  @Output() onProcessComplete = new EventEmitter<any>();

  authDetails: any;
  pendedDialogId: any;
  selectedCheckBoxValue: any;

  actionButtons: TableRowActionsModel = new TableRowActions({ view: true });
  programName: any;
  @Input() timeoffData: any;
  @Input() isTimeOff: any;
  reasonList: any;
  statusList: any;
  timesheetData: any;
  dispositionReason: any;
  timesheetDisposition: any;
  processingStatusList: any;
  action = '';
  errorCodes: any;
  errorcodeData: any;
  deniedData: any;
  authData: any;
  mode = 'view';
  timeEntry = 'timeEntry';
  payPeriod: any[] = [];
  filetredPayPeriod: any;
  @Input() timesheetFor?: string = 'staff';
  disableEditingPendedTimesheet = false;
  @Input() isReadOnly = false;
  canRevertTS = false;
  isAdjustedTS = false;

  timeoff_cols = [
    {
      field: 'serviceDate',
      header: 'Service \nDate',
      jsonpath: 'serviceDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'createdDate',
      header: 'Submission \nDate',
      jsonpath: 'createdDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'serviceDescription',
      header: 'Service \nDescription',
      jsonpath: 'serviceDescription',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'timeIn',
      header: 'Time \nIn',
      jsonpath: 'timeIn',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'timeOut',
      header: 'Time \nOut',
      jsonpath: 'timeOut',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'billedUnits',
      header: 'Billed Units \n(15 Mins \nIncrement)',
      jsonpath: 'billedUnits',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'billedUnitsInHrs',
      header: 'Billed \nUnits \n(hrs)',
      jsonpath: 'billedUnitsInHrs',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'paidUnits',
      header: 'Paid \nUnits \n(hrs)',
      jsonpath: 'paidUnits',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'serviceRate',
      header: 'Service \nRate',
      jsonpath: 'serviceRate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'manualReason',
      header: 'Manual \nReason',
      jsonpath: 'manualReason',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'businessStatus',
      header: 'Business \nStatus',
      jsonpath: 'businessStatus',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'source_type_lkp',
      header: 'Submission \nSource',
      jsonpath: 'source_type_lkp',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'approvalSourceType',
      header: 'Approval \nSource',
      jsonpath: 'approvalSourceType',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'mco_name',
      header: 'MCO \nName',
      jsonpath: 'mco_name',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    }
  ];

  constructor(
    private dateTimeFormatterService: DateTimeFormatterService,
    private lookupService: LookupService,
    private timesheetService: TimesheetService,
    private errorAlertService: ErrorAlertService,
    private listService: ListService,
    private sectionService: SectionsService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();

    this.programName = selectedProgram?.program_code ?? '';

    if (!this.isProviderView) {
      this.timeoff_cols.push({
        field: 'processingStatus',
        header: 'Processing \nStatus',
        jsonpath: 'processingStatus',
        isDisplayedAtHeader: 'y',
        isSearchable: 'n',
      });

      if (!this.isTimeOff) {
        this.timeoff_cols.push({
          field: 'authNum',
          header: 'Auth # \nNumber',
          jsonpath: 'authNum',
          isDisplayedAtHeader: 'y',
          isSearchable: 'n',
        });
      }

      if (this.isTimeOff) {
        this.timeoff_cols = this.timeoff_cols.filter(e => e.field != 'manualReason');
      }
    }

    const decisionDetailsAuthorizedRoles = ["PPL Admin", "Compliance", "Enrollment Specialist", "PPL Staff Tier 1", "Paper Timesheet Processor",
      "Fulfillment Staff", "PAVTraining", "PAVAdmin", "BAVAdmin", "PPL HR Staff", "FI Admin", "CDPAP Facilitator Tier 2", "State Admin"];
    const decisionDetailsAuthorizedLookup = ["FMS", "FI", "State"];
    const userDetails = this.userService.getUserDetails();
    if (userDetails?.usertype_lkp) {
      this.canRevertTS = this.userService.isSelectedRole('PAVAdmin');
      const isDecisionDetailsUserAuth = this.userService.isSelectedRole(decisionDetailsAuthorizedRoles)
        && decisionDetailsAuthorizedLookup.includes(userDetails.usertype_lkp);

      if (isDecisionDetailsUserAuth) {
        this.timeoff_cols = [
          ...this.timeoff_cols,
          {
            field: 'consumerDecisionDate',
            header: 'Decision \nTimestamp',
            jsonpath: 'consumerDecisionDate',
            isDisplayedAtHeader: 'y',
            isSearchable: 'n',
          },
          {
            field: 'consumerDecisionBy',
            header: 'Decision \nBy',
            jsonpath: 'consumerDecisionBy',
            isDisplayedAtHeader: 'y',
            isSearchable: 'n',
          }
        ];
      }
    }

    this.getPayPeriod();
    this.reasonList = this.lookupService.getLookupValue('Manual Entry reason');
    this.statusList = this.lookupService.getLookupValue('Business Status');
    this.processingStatusList = this.lookupService.getLookupValue('TS_App_S');
    this.dispositionReason = this.lookupService.getLookupValue('Disposition Reason');
    this.timesheetDisposition = this.lookupService.getLookupValue('TimeSheet Disposition');
    if (!this.timeoffData) {
      this.loadRecords();
    } else {
      this.timeoffData.forEach((item: any) => {
        item.billedUnitsInHrs = (item.billedUnits * 15) / 60;
        item.paidUnits = item.paidUnits ? (item.paidUnits * 15) / 60 : null;
        if (item.createdDate) {
          item.createdDate = this.dateTimeFormatterService.formatDateTimeNoSeconds(item.createdDate);
        }
        if (item.consumerDecisionDate) {
          item.consumerDecisionDate = this.dateTimeFormatterService.formatDate(item.consumerDecisionDate, 'MM/dd/yyyy');
        }
      });
    }
  }

  getPayPeriod() {
    this.timesheetService
      .getPayPeriod(this.programName)
      .subscribe((data: any) => {
        this.payPeriod = data.responsedata;
      });
  }

  onEdit() {
    this.filetredPayPeriod = this.filterPayrollDates(this.payPeriod, 'timeEntry');
    this.timeoffData.forEach((e: any) => {
      e.serviceTimeIn = e.timeIn;
      e.serviceTimeOut = e.timeOut;
      e.timeSheetDetailId = e.timesheetLineId;
      e.applicationStatusLkp = e.processingStatusLkp;
    });

    this.timesheetData = {
      serviceLines: this.timeoffData,
      payrollScheduleId: this.lineItem.servicePeriodId,
      consumer: {
        consumerId: this.lineItem.consumerId,
        consumerPplId: this.lineItem.consumerPplId,
        consumerFullName: this.lineItem.consumerName
      },
      provider: {
        providerId: this.rowData.providerId,
        providerPplId: this.rowData.providerPplId
      }
    }
    this.mode = 'edit';
    this.action = 'edit';
  }

  onRevert(){
    if (!this.selectedCheckBoxValue?.length) {
      const errorMessage = 'Please select lines for completing this action.';
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    if (this.selectedCheckBoxValue?.length > 1) {
      const errorMessage = 'Please select only one line for completing this action.';
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    const totalInvalidProcessSelected = this.selectedCheckBoxValue.filter((e: any) => e.processingStatusLkp != 'AD');
    if (totalInvalidProcessSelected.length > 0) {
      const errorMessage = 'Please select only Adjusted timesheets for completing this action.';
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    const selectedIds = this.selectedCheckBoxValue.map((item: any) => item.timesheetLineId);
    const payload = {
                      "programCode": this.programName,
                      "timesheetLineDetailIds": selectedIds
                    };

    this.timesheetService.revertTimesheet(payload).subscribe((data: any) => {
      if (data.status === 200) {
        this.onProcessComplete.emit(data);
      }
    });
  }

  onCancel(event: any) {
    this.mode = 'view';
    this.action = 'view';
    if (event?.isTimesheetDeleted) {
      this.loadRecords();
    }
  }

  loadRecords() {
    const filters = [
      {
        jsonPath: "participantId",
        value: this.lineItem.consumerId,
        operator: "Equal"
      },
      {
        jsonPath: "providerId",
        value: this.rowData.providerId,
        operator: "Equal"
      },
      {
        jsonPath: "tasMasterPayrollScheduleId",
        value: this.rowData.tasMasterPayrollScheduleId,
        operator: "Equal"
      },
      {
        jsonPath: "servicePeriodId",
        value: this.lineItem.servicePeriodId,
        operator: "Equal"
      },
    ];
    this.searchTimesheets(filters);
  }

  buildRequestPayload(pageName: string, searchParams: []) {
    if (searchParams.length == 0) {
      //handle the error here
      return;
    }

    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: '1',
      searchParam: searchParams,
      orderByColumn: [],
      orderBy: ['desc'],
    };
    return payload;
  }

  searchTimesheets(filters: any) {
    const processedPayload = this.buildRequestPayload(
      'staffEditTimesheetEntry',
      filters
    );
    this.listService
      .getListData(processedPayload, 'claims')
      .subscribe((data: any) => {
        this.timeoffData = this.processData(data.responsedata);
        this.isAdjustedTS = this.timeoffData.some((data:any)=>{
          return data.processingStatusLkp === 'AD'
        })
      });
  }

  handlePendedTimesheet(event: any, allowEdit: boolean) {
    this.disableEditingPendedTimesheet = this.isReadOnly ? true : allowEdit;
    const timesheetLineId = event.event.timesheetLineId;
    console.log("timesheetLineId", timesheetLineId);
    const filters: any = [
      {
        jsonPath: "timesheetId",
        value: timesheetLineId,
        operator: "Equal"
      }
    ];
    const errorListPayload = this.buildRequestPayload(
      'timesheet-processCode',
      filters
    );
    this.listService
      .getListData(errorListPayload, 'claims')
      .subscribe((data: any) => {
        this.errorcodeData = data.responsedata;
        this.openPendedDialog(`${event.event.processingStatus} Timesheet`);
      });
  }

  rowClickedTs(event: any) {
    if (event.col?.field === 'authNum') {
      this.timesheetService
        .getAuthDetails(this.programName, event.event.timesheetLineId)
        .subscribe((data: any) => {
          this.authData = data.responsedata;
          this.openAuthDataDialog();
        });
    }
    else if ((event.col?.field === 'processingStatus' || event.col?.field === 'businessStatus') && ['Pended'].includes(event.event.processingStatus)) {
      // allow saving pended timesheets
      this.handlePendedTimesheet(event, false);
    }
    else if ((event.col?.field === 'processingStatus' || event.col?.field === 'businessStatus') && CommonUtil.hasInfoStatus(event.event.processingStatus)) {
      // allow do not allow edits
      this.handlePendedTimesheet(event, true);
    }
    else if ((event.col?.field === 'processingStatus' || event.col?.field === 'businessStatus') && event.event.processingStatus === 'Denied') {
      const payload = {
        pageName: 'timesheet-processCode',
        programCode: this.programName,
        condition: 'and',
        recordsPerPage: 20,
        startingPageNumber: 1,
        searchParam: [
          {
            jsonPath: 'timesheetId',
            value: event.event.timesheetLineId,
            operator: 'Equal',
          },
        ],
        orderByColumn: ['id'],
        orderBy: ['desc'],
      };
      this.listService
        .getListData(payload, 'claims')
        .subscribe((data: any) => {
          this.deniedData = data.responsedata;
          this.deniedData.forEach((e: any) => {
            if (e.reasonLkp) {
              e.reason = this.dispositionReason.filter((d: any) => d.lkpValueCode == e.reasonLkp)[0].lkpValueName;
            }

            if (e.dispositionLkp) {
              e.disposition = this.timesheetDisposition.filter((d: any) => d.lkpValueCode == e.dispositionLkp)[0].lkpValueName
            }
          });
          this.openDeniedDialog();
        });
    }
  }


  showAuthDetails(event: any) {
    if (event.clientAuthNumber) {
      this.authDetails = event;
      this.openAuthDialog();
    }
  }

  openAuthDialog() {
    this.sectionService.setFlow('authorizations');
    this.userService.setLeadEntry('authorizations');
    this.userService.setSelectedLead(this.authDetails.tasAuthorizationDetailId);
    const dialogConfig: DialogConfig = {
      title: `Auth Details for ${this.authDetails.clientAuthNumber}`,
      isOkText: 'Deny',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.authDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  openPendedDialog(title: string) {
    const dialogConfig: DialogConfig = {
      title: title,
      isOkText: 'Ok',
      size: 'x-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.pendedDialogId = this.dialogSvc.openDialog(
      this.pendedDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  openDeniedDialog() {
    const dialogConfig: DialogConfig = {
      title: `Denied Timesheet`,
      isOkText: 'Ok',
      size: 'x-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.deniedDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  openAuthDataDialog() {
    const dialogConfig: DialogConfig = {
      title: `Auth Data`,
      isOkText: 'Ok',
      size: 'x-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.authDataDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  handleCancel() {

  }

  rowClicked(event: any) {

  }

  onSaveAdjustment(event: any) {
    this.dialogSvc.closeDialog(this.pendedDialogId);
    this.pendedDialogId = null;
    this.loadRecords();
  }

  onProcessClick() {
    console.log('selectedCheckBoxValue---', this.selectedCheckBoxValue);
    if (!this.selectedCheckBoxValue?.length) {
      const errorMessage = 'Please select lines for completing this action.';
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    const totalInvalidProcessSelected = this.selectedCheckBoxValue.filter((e: any) => e.processingStatusLkp != 'PE' && e.processingStatusLkp != 'SB' && e.processingStatusLkp != 'SE');
    if (totalInvalidProcessSelected.length > 0) {
      const errorMessage = 'Please select only Pending or Submitted or System Error timesheets.';
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    const selectedIds = this.selectedCheckBoxValue.map((item: any) => item.timesheetLineId);
    const payload =
    {
      "programCode": this.programName,
      "timesheetlineDetailIds": selectedIds
    };

    this.timesheetService.updateTimesheetAdjudication(payload).subscribe((data: any) => {
      if (data.status === 200) {
        this.onProcessComplete.emit(data);
      }
    });
  }

  selectionChanged(event: any) {
    this.selectedCheckBoxValue = event;
  }

  processData(data: any[]) {

    data.forEach(e => {
      const businessStatus = this.statusList.find((gen: LookupValueItem) => {
        return gen.lkpValueCode === e.businessStatusLkp;
      });

      if (businessStatus) {
        e.businessStatus = businessStatus.lkpValueName;
      }

      const processingStatus = this.processingStatusList.find((gen: LookupValueItem) => {
        return gen.lkpValueCode === e.processingStatusLkp;
      });

      if (processingStatus) {
        e.processingStatus = processingStatus.lkpValueName;
      }

      const reason = this.reasonList.find((gen: LookupValueItem) => {
        return gen.lkpValueCode === e.reasonLkp;
      });

      if (reason) {
        e.reason = reason.lkpValueName;
      }

      if (STATIC_DATA.STATUS_FOR_AUTH.includes(e.businessStatusLkp) || STATIC_DATA.PROCESSING_STATUS_FOR_AUTH.includes(e.processingStatusLkp)) {
        e.authNum = 'View';
      }

      e.billedUnitsInHrs = (e.billedUnits * 15) / 60;
      e.paidUnits = e.paidUnits ? (e.paidUnits * 15) / 60 : null;
      e.createdDate = this.dateTimeFormatterService.formatDateTimeNoSeconds(e.createdDate);
      e.consumerDecisionDate = this.dateTimeFormatterService.formatDate(e.consumerDecisionDate, 'MM/dd/yyyy');
    });

    data.sort((a, b) => {
      const dateA = new Date(a.serviceDate + ' ' + a.timeIn) as any;
      const dateB = new Date(b.serviceDate + ' ' + b.timeIn) as any;

      // Sorts by serviceDate and timeIn in ascending order
      return dateA - dateB;
    });

    return data;
  }

  timesheetAdded(event: any) {
    this.timeoffData = [];
    this.loadRecords();
    this.onCancel({ isTimesheetDeleted: false });
  }


  filterPayrollDates(payrolls: any, flow: any) {
    const today = new Date();
    if (flow === 'timeEntry') {
      return payrolls.filter((payroll: any) => {
        const startDate = new Date(payroll.payrollStartDate);
        const endDate = new Date(payroll.payrollEndDate);
        return startDate <= today || (today >= startDate && today <= endDate);
      });
    }
    else {
      return payrolls.filter((payroll: any) => {
        const startDate = new Date(payroll.payrollStartDate);
        const endDate = new Date(payroll.payrollEndDate);
        return (startDate >= today || (today >= startDate && today <= endDate));
      });
    }
  };
}
